function decimalPlaces(num)
{
    var result = 0;
    var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (match)
    {
        result = Math.max(
            0,
            // Number of digits right of decimal point.
            (match[1] ? match[1].length : 0)
            // Adjust for scientific notation.
            - (match[2] ? +match[2] : 0));
    }
    return result;
}

function getParameterByName(name, url)
{
    if (!url) url = window.location.href;

    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export default {
    decimalPlaces,
    getParameterByName
};



// WEBPACK FOOTER //
// ./CMS/scripts/util/helper.js